import { render, staticRenderFns } from "./GridNoneFavorite.vue?vue&type=template&id=4483f3a4&scoped=true&"
import script from "./GridNoneFavorite.vue?vue&type=script&lang=js&"
export * from "./GridNoneFavorite.vue?vue&type=script&lang=js&"
import style0 from "./GridNoneFavorite.vue?vue&type=style&index=0&id=4483f3a4&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4483f3a4",
  null
  
)

export default component.exports